import { CampfireRichEditor } from '@campfire/campfire-rich-editor/lib';
import { HoverText } from '@campfire/hover-link/lib';
import { Grid, Typography } from '@material-ui/core';
import { convertFromRaw, EditorState } from 'draft-js';
import React, { useMemo } from 'react';
import { GetForm_vm_form_formItems_VOLUNTEER_FormItemContentType as ContentFormItemType } from '../../__generated__/GetForm';
import { useFormBuilderDialogContext } from '../FormBuilderDialogContext';

interface Props {
  data: ContentFormItemType;
}

export const ContentFormItem = (props: Props) => {
  const { data } = props;
  const { editContent } = useFormBuilderDialogContext();
  const content = useMemo(() => EditorState.createWithContent(convertFromRaw(JSON.parse(data.content))), [
    data.content,
  ]);

  const hasRichContent = content.getCurrentContent().hasText();

  return (
    <Grid container spacing={1} style={{ padding: 24 }}>
      <Grid item xs>
        <Typography variant='body2' color='textSecondary'>
          {'Content'}
        </Typography>
      </Grid>
      <Grid item>
        <HoverText color='primary' onClick={() => editContent(data)}>
          {'Edit content'}
        </HoverText>
      </Grid>
      <Grid item xs={12}>
        {hasRichContent && <CampfireRichEditor editorState={content} />}
      </Grid>
    </Grid>
  );
};
